<div id="footerContainer" class="footer-container">
    <div id="footer" class="footer-banner">
        <div class="connect-with-us">Connect with us</div>
        <div>
            <a href="http://www.facebook.com/TotalQualityLogistics" rel="noopener noreferrer nofollow" target="_blank"><img src="assets/images/Facebook.png" /></a>
            <a href="https://twitter.com/TQLogistics" rel="noopener noreferrer nofollow" target="_blank"><img src="assets/images/Twitter.png" /></a>
            <a href="http://www.youtube.com/user/TQLogistics" rel="noopener noreferrer nofollow" target="_blank"><img src="assets/images/YouTube.png" /></a>
            <a href="http://www.linkedin.com/company/total-quality-logistics" rel="noopener noreferrer nofollow" target="_blank"><img src="assets/images/LinkedIn.png" /></a>
        </div>
        <div class="right-links">
          <a href="http://www.tql.com/privacy" rel="noopener noreferrer nofollow" target="_blank" class="links">Privacy and Cookies Policy</a>
          <a href="http://www.tql.com/terms" class="links" rel="noopener noreferrer nofollow" target="_blank">Terms of Use</a>
          <a href="https://www.tql.com/eula-trax" class="links" rel="noopener noreferrer nofollow" target="_blank">License Agreement</a>
          <a target="_self" class="links privacy-policy" rel="noopener noreferrer nofollow" onclick="OneTrust.ToggleInfoDisplay()">Your Privacy Choices<img src="assets/icons/CCPA-icon.svg" /></a>
        </div>
    </div>
</div>
